export default __webpack_public_path__ + "static/fundo-opaco-ee5e1b1fb4ed279567e0a1ea4b931f2a.png";